import { TGroupFormData } from 'src/@types';
import { IGroupSFilter } from 'src/@types/SearchFilterTypes';
import { IGroup } from 'src/models';
import objectToQueryString from 'src/utils/objectToQueryString';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/oprtrGroup';

/**
 * 그룹 목록 조회
 */
export const getGroups = async (searchFilter?: IGroupSFilter) => {
  try {
    const url = '/oprtrGroup' + objectToQueryString(searchFilter || {});
    const response = await instance.get<TApiResponseData<IGroup[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 그룹 목록 조회
 */
export const getDetail = async (oprtrGroupSid: number) => {
  try {
    const url = `${SUB_URL}/${oprtrGroupSid}`;
    const response = await instance.get<TApiResponseData<IGroup>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 권한그룹명 중복 확인
 * @param oprtrGroupNm 권한그룹명
 */
export const checkDuplicateGroupNm = async (oprtrGroupNm: string) => {
  const url = `v1/oprtrGroup/oprtrGroupNm/check?oprtrGroupNm=${oprtrGroupNm}`;
  const response = await instance.get<TApiResponseData<boolean>>(url);

  // 성공 시 데이터 반환
  if (response.data.resultCode === 'S') {
    return {
      data: response.data.data,
    };
  }
};

/**
 * 권한그룹 정보 등록
 * @param groupInfo 권한그룹 등록 정보: TGroupFormData
 */
export const createGroup = async (groupInfo: TGroupFormData) => {
  const url = SUB_URL;
  const payload = groupInfo;
  const response = await instance.post<TApiResponseData<IGroup>>(url, payload);

  // 성공 시 데이터 반환
  if (response.data.resultCode === 'S') {
    return {
      data: true,
    };
  }
};

/**
 * 권한그룹 정보 수정
 * @param oprtrGroupSid 권한그룹 고유번호
 * @param groupInfo 권한그룹 등록 정보: TGroupFormData
 */
export const updateGroup = async (oprtrGroupSid: number, groupInfo: TGroupFormData) => {
  const url = `${SUB_URL}/${oprtrGroupSid}`;
  const payload = groupInfo;
  const response = await instance.put(url, payload);

  // 성공 시 데이터 반환
  if (response.data.resultCode === 'S') {
    return {
      data: true,
    };
  }
};

/**
 * 그룹 삭제
 */
/**
 * 그룹 정보 삭제
 * @param oprtrGroupSid 그룹 고유번호
 */
export const removeGroup = async (oprtrGroupSid: number) => {
  try {
    const url = `${SUB_URL}/${oprtrGroupSid}`;
    const response = await instance.delete<TApiResponseData<IGroup>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    throw new Error(
      response.data.resultCode === 'F' && response.data.errorMessage
        ? response.data.errorMessage
        : '그룹정보 삭제에 실패했습니다.',
    );
  } catch (error) {
    console.error(error);
    return {
      success: false,
      errorMessage: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
